__turbopack_context__.v({
  "teasers": "Exnshq_teasers",
});
